import { Grid, List, Popover, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";
import type { DimensionDescriptor } from "../../../../../../../../../api/types/svTypes.ts";
import MetaIcon from "../../../../common/MetaIcon.tsx";

interface Props {
  dimensions: DimensionDescriptor[];
  anchorEl: HTMLElement | null;
  onClose: (field?: DimensionDescriptor) => void;
}
export default function CustomMeasureDimensionSelection({ dimensions, anchorEl, onClose }: Props) {
  const maxHeight = useMemo(() => getContainerHeight(dimensions), [dimensions]);

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => onClose()}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          sx: {
            boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)",
            maxHeight: maxHeight,
            overflow: "hidden",
          },
        },
      }}
    >
      <Stack
        spacing="1rem"
        useFlexGap
        sx={(theme) => ({
          flex: 1,
          height: maxHeight,
          width: "100%",
          "& .MuiSvgIcon-root": {
            color: theme.palette.secondary.light,
          },
        })}
      >
        <Grid container sx={{ height: "100%", width: "100%", overflow: "auto", px: 1 }}>
          <List sx={{ width: "100%" }}>
            {dimensions.map((item) => (
              <PopoverMenuItem key={`${item.name}`} sx={{ pl: 1, gap: 1.5 }} onClick={() => onClose(item)}>
                <MetaIcon icon={item.icon} />
                <Typography>{item.caption}</Typography>
              </PopoverMenuItem>
            ))}
          </List>
        </Grid>
      </Stack>
    </Popover>
  );
}

function getContainerHeight(dimensions: DimensionDescriptor[]) {
  const listYasixPaddingsSum = 16;
  const listItemsHeight = 32;
  const maxAvailableItemsNumber = 4;
  return `${Math.min(dimensions.length, maxAvailableItemsNumber) * listItemsHeight + listYasixPaddingsSum}px`;
}
